import CalendarItemProps from "./props";

/* A calendar item doesn't actually render anything. */
export default (props: CalendarItemProps): JSX.Element => null;

